export const getSquadsMembers = (limit, offset) => {
  return `
      SELECT
        Id,
        Name,
        Name__c,
        Time__c,
        Nome_do_Outlook__c,
        Email_do_SalesForce__c,
        Name__r.Profile.Name,
        Mesa_Opera_o__c,
        Mesa_Opera_o__r.Name,
        Mesa_Opera_o__r.Id,
        Mesa_Opera_o__r.Lider__c,
        Mesa_Opera_o__r.Lider__r.Nome_do_Outlook__c,
        Mesa_Opera_o__r.Lider__r.Email_do_Salesforce__c,
        Mesa_Opera_o__r.Lider__r.Name,
        Mesa_Opera_o__r.Planning_Department__c,
        Nivel_do_Ecossistema__c,
        LOP_Group__c,
        Canal_LOP__c,
        Canal_de_Atendimento__c,
        Data_de_contratacao__c,
        Tipo_de_contratacao__c,
        Status__c
      FROM
        Membros__c
      WHERE
        Mesa_Opera_o__c != ''
        AND Email_do_Salesforce__c != null
        AND Name__c != null
        AND Name__r.IsActive = true
      ORDER BY Nome_do_Outlook__c      
      LIMIT ${limit}
      OFFSET ${offset}
    `;
};
